import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { LineItemInterface, StyledLineItem } from './LineItem'
import Button from 'library/atoms/Button'
import { defined, definedNotNull } from 'shared/presenters/presenter'
import { H5 } from 'library/atoms/Typography'
import {
  MEMBERSHIPS_DURATION_TRANSLATION,
  MEMBERSHIPS_TITLE
} from 'enums/memberships'
import determineTopLevelChargeableImage from 'helpers/determineTopLevelChargeableImage'
import Divider from 'shared/library/atoms/Divider'
import Flex from 'shared/library/atoms/Flex'
import Price, { PriceText, PriceWrapper } from 'shared/library/atoms/Price'
import Thumbnail from 'shared/library/atoms/Thumbnail'
import { MembershipPresenter } from 'shared/presenters'

const LineItemMembership = ({
  item,
  outlet,
  removeItemOnClick,
  removeItemLoading
}: LineItemInterface) => {
  const { t } = useTranslation('chargeable')

  // TODO - Introduce data to view item - Issue #3651
  const chargeableReviewData = undefined

  const membershipProduct = new MembershipPresenter(
    definedNotNull(
      item?.membership_subscription?.membership_price?.membership_product
    )
  )
  const membershipPrice = item?.membership_subscription?.membership_price

  return (
    <StyledLineItem key={item.id}>
      <Flex alignItems="center">
        <Thumbnail
          src={determineTopLevelChargeableImage({
            outlet: outlet,
            title: MEMBERSHIPS_TITLE
          })}
        />
        <Flex flexDirection="column" ml={2}>
          <H5 mb={3}>{membershipProduct.name()}</H5>

          <PriceWrapper color="secondary">
            <Price
              pence={defined(membershipPrice?.sign_up_fee)}
              currency={outlet.currency()}
            />
            <PriceText color="secondary">{` / ${t('sign-up-fee')}`}</PriceText>
          </PriceWrapper>

          <PriceWrapper color="secondary">
            <Price
              pence={definedNotNull(membershipPrice?.unit_amount)}
              currency={outlet.currency()}
            />
            <PriceText color="secondary">
              {` / ${t(
                MEMBERSHIPS_DURATION_TRANSLATION[
                  defined(membershipPrice?.recurring_interval)
                ],
                {
                  count: membershipPrice?.recurring_interval_count
                }
              )}`}
            </PriceText>
          </PriceWrapper>
        </Flex>
      </Flex>
      {(removeItemOnClick || chargeableReviewData) && (
        <>
          <Divider my={4} variant="solid" />
          <Flex justifyContent="space-between">
            {removeItemOnClick && (
              <Button
                variant="tertiary"
                loading={removeItemLoading}
                inactive={removeItemLoading}
                onClick={() => {
                  removeItemOnClick(definedNotNull(item.id))
                }}
                aria-label={t('remove-membership')}
              >
                {t('common:delete')}
              </Button>
            )}
          </Flex>
        </>
      )}
    </StyledLineItem>
  )
}

export default LineItemMembership
